module.exports = "\n#ifdef USE_SHADOWMAP\nout vec4 vShadowCoord;\nuniform mat4 shadowMatrix;\n#endif\n";